module.exports = __webpack_public_path__ + "static/media/stiwi.509a458b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/stiwi.jpg
// module id = 611
// module chunks = 0